export enum PostDetailsType {
  BY_ID = 'BY_ID',
  BY_SLUG = 'BY_SLUG'
}

export type IProps = {
  detailsType: PostDetailsType;
};
